export const C1Transitions = {
    duration: {
        // MUI defaults
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,

        // C1 overrides
        enteringScreen: 200,
        leavingScreen: 150,
    },
    easing: {
        // MUI defaults
        easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
        easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
        sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',

        // C1 overrides
        linearSpringA: 'linear(0.00, 0.0450, 0.126, 0.229, 0.346, 0.467, 0.584, 0.693, 0.790, 0.873, 0.942, 0.996, 1.04, 1.07, 1.08, 1.09, 1.10, 1.09, 1.09, 1.08, 1.07, 1.05, 1.04, 1.03, 1.02, 1.01, 1.01, 1.00, 0.997, 0.994, 0.992, 0.991, 0.991, 0.991, 0.991, 0.992, 0.993, 0.994, 0.996, 0.997, 0.998, 0.998, 0.999, 1.00)',
        linearSpringB: 'linear(0, 0.0023, 0.009 0.96%, 0.0341, 0.0725 2.87%, 0.1356 4.07%, 0.2604 5.99%, 0.6939 11.97%, 0.8124 13.89%, 0.9007 15.56%, 0.9827, 1.0443, 1.087 21.31%, 1.1019, 1.1129 23.22%, 1.1218, 1.1259 25.62%, 1.1254, 1.1203 28.49%, 1.1025 31.12%, 1.0436 37.59%, 1.0178 40.94%, 1.0063, 0.9974, 0.991 46.68%, 0.9865 48.84%, 0.9842 51.47%, 0.9847 54.58%, 0.9975 66.79%, 1.0015 73.98%, 0.9998 99.83%)',
        linearSpringC: 'linear(0, 0.000960, 0.00687, 0.0172, 0.0315, 0.0494, 0.0704, 0.0941, 0.120, 0.148, 0.178, 0.210, 0.242, 0.276, 0.310, 0.344, 0.378, 0.413, 0.447, 0.481, 0.515, 0.548, 0.580, 0.612, 0.642, 0.672, 0.701, 0.728, 0.755, 0.780, 0.804, 0.827, 0.849, 0.869, 0.888, 0.907, 0.924, 0.939, 0.954, 0.968, 0.980, 0.992, 1.00, 1.01, 1.02, 1.03, 1.03, 1.028, 1.026, 1.024, 1.022, 1.020, 1.018, 1.016, 1.014, 1.012, 1.01, 1.008, 1.006, 1.004, 1)',
    },
}

export const skeletonFadeInSx = { animation: 'fadeIn 0.3s ease-out 150ms both' }
